import React from "react";
import Text from '@ingka/text';
import "../../app.scss"
import { PPSTemplate } from "./pps-template";

export const PPSDashboard: React.FC = () => {

  return (
    <PPSTemplate>
        <Text tagName="p" textStyle="Statement.M">
          Product propensity scores are probabilities quantifying individual customer's interest in a particular
          product or product area. 
          <br/>
          <br/>
          The scores are available at product area (pa) or product range area (pra) and home furnishing business (hfb). Please 
          specify the pa_no/pra_no/hfb_no that will be highlighted in your campaign.
          <br/>
          <br/>
          You cannot combine pa_no with pra_no or hfb_no. In the case of pa or pra, 
          they would be entered in the first field (the list of existing item_no/pa_no/pra_no).
          <br/>
          <br/>
          <span className="grey-text">
          You may use an excel file instead of the fields below if you are predicting using item_no. 
          Only provide an excel file if you have filled it in with item_no values.
          <br/>
          <br/>
          File must look exactly like template but with replaced values.
          <br/>
          <br/>
          </span>
          Any code within the IKEA catalog can be included.
        </Text>
    </PPSTemplate>  
  )
}